import React, { ReactNode } from 'react';
import Upload from 'rc-upload';

interface Props {
  accept: string;
  onPick: (file: File) => void;
  children: ReactNode;
  multiple?: boolean;
  disabled?: boolean;
}

export default function FilePicker({
  accept,
  onPick,
  children,
  multiple,
  disabled,
}: Props) {
  return (
    <Upload
      accept={accept}
      multiple={multiple}
      disabled={disabled}
      beforeUpload={(file) => {
        onPick(file);
        return false;
      }}
    >
      {children}
    </Upload>
  );
}

FilePicker.defaultProps = {
  multiple: false,
  disabled: false,
};
